import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        margin: '20px auto',
        width: '80%',
        borderRadius: '10px',
        maxHeight: '83vh',
        overflowY: 'auto',
        paddingTop:'40px',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
            maxHeight: '85vh',
            paddingTop:'55px',
        },
    },
    title: {
        color: '#FF6900 !important',
        fontWeight: '700 !important',
        textAlign: 'center',
        marginTop: '20px',
        fontSize: '35px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '20px !important',
            marginTop: 0,
            textAlign: 'left',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            wordBreak: 'break-word',
            minWidth: 0,
        },
    },
    titleRow: {
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignItems: 'center',
            gap: '12px',
            paddingLeft: '16%',
            paddingTop: '8px !important'
        },
    },
    titleBlock: {
        [theme.breakpoints.down('sm')]: {
            flex: '1 1 0',
            minWidth: 0,
            overflow: 'hidden',
        },
    },
    actionsBlock: {
        [theme.breakpoints.down('sm')]: {
            flexShrink: 0,
            flexDirection: 'row',
        },
    },
    cardsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '15px',
        width: '92%',
        [theme.breakpoints.down('sm')]: {
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '8px',
        },
    },
    card: {
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        height:'120px',
        borderRadius: '12px',
        padding: '15px',
        textAlign: 'center',
        backgroundColor: '#ffffff !important',
        border: '1px solid #e8e8e8',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        color:'#1a1a1a !important',
        width: '32%',
        [theme.breakpoints.down('sm')]: {
            justifyContent:'flex-start',
            height:'auto',
            width: '100%',
            boxSizing: 'border-box',
            margin: '0',
        },
    },
    overviewContainer:{
        backgroundColor:'var(--brand-bg, #EFEFEF)',
        borderRadius:'10px',
        padding:'20px',
        width:'92%',
        display:'flex',
        [theme.breakpoints.down('sm')]: {
            flexDirection:'column',
            '& .MuiTypography-body1': { fontSize: '13px !important' },
            '& .MuiTypography-h6':    { fontSize: '13px !important' },
        },
    },
    overview: {
        marginTop: '10px',
        marginBottom: '10px',
        fontSize: '16px',
        textAlign: 'left',
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
        },
    },
    unit: {
        marginBottom: '10px',
        textAlign: 'left',
    },
    lesson: {
        color: '#0097B2',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0px',
        },
    },
    studentOutcomes: {
        paddingLeft: '30px',
        color: 'var(--brand-text, #474747)',
    },
    unitContainer: {
        width: '92%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'left',
        marginTop: '15px',
        alignItems: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            '& .MuiTypography-body1':    { fontSize: '13px !important' },
            '& .MuiTypography-body2':    { fontSize: '13px !important' },
            '& .MuiTypography-subtitle1':{ fontSize: '13px !important' },
        },
    },
    button: {
        marginTop: '10px',
        backgroundColor: '#0397a6',
        justifyContent: 'left',
        outline: 'none',
        color: '#fff',
        '&:hover': {
            backgroundColor: '#027A85',
        },
    },
    chatBotContainer:{
        position: 'absolute',
        width: '65%',
        bottom:'0',
        padding: '0px',
        borderRadius: '7px',
        [theme.breakpoints.down('sm')]: {
            width: '95%',
        },
    }
}));

export default useStyles;